import dayjs from 'dayjs';
import type { Dayjs } from 'dayjs';
import { Month } from '../../types';

const monthMap: Record<Month, number> = {
  [Month.JANUARY]: 0,
  [Month.FEBRUARY]: 1,
  [Month.MARCH]: 2,
  [Month.APRIL]: 3,
  [Month.MAY]: 4,
  [Month.JUNE]: 5,
  [Month.JULY]: 6,
  [Month.AUGUST]: 7,
  [Month.SEPTEMBER]: 8,
  [Month.OCTOBER]: 9,
  [Month.NOVEMBER]: 10,
  [Month.DECEMBER]: 11,
};

const getYearForSelection = (calendarYear: string, calendarMonth: Month) => {
  const monthIndex = monthMap[calendarMonth];
  if (monthIndex >= 8) {
    return parseInt(calendarYear.split('/')[0]);
  } else {
    return parseInt(calendarYear.split('/')[1]);
  }
};

export const getDateConstraints = (calendarYear: string, calendarMonth: Month) => {
  const year = getYearForSelection(calendarYear, calendarMonth);
  const monthIndex = monthMap[calendarMonth];

  const monthStart = dayjs(`${year}-${(monthIndex + 1).toString().padStart(2, '0')}-01`);

  return {
    disabledDate: (current: Dayjs) => current.year() !== year || current.month() !== monthIndex,
    defaultPickerValue: monthStart,
  };
};
